import { updateQueryCache } from 'api/urql/helpers/mutation';
import { query as getBadges } from '../../../../../queries/badges/getBadges';

export const createBadge = (results, args, cache, info) => {
  updateQueryCache({
    fieldName: 'allBadges',
    query: getBadges,
    handleCacheUpdate: (data) => {
      data.allBadges.push(results.createBadge.badge);
      return data;
    },
  })(results, args, cache, info);
};
